import { useFeatureFlagEnabled } from "posthog-js/react";

export const useIsWorkflowTrackerEnabled = () =>
  useFeatureFlagEnabled("enable_new_onboarding_in_progress_flow") ?? false;
